import moment from "moment"

const displayTime = dateTime => {
  if (moment().diff(dateTime, "days") < 1) {
    return moment(dateTime).format("a h:mm")
  }

  return moment(dateTime).format("YYYY-MM-DD")
}

export default displayTime
